import {yupResolver} from '@hookform/resolvers/yup';
import {object} from 'yup';

import {BirthSex, MeasurementUnit} from '#apollo/schema';
import {Pronoun} from '#constant/prounouns';
import {
  dateValidator,
  heightValidator,
  measurementUnitRequiredValidator,
  numberValidator,
  pronounValidator,
  stringValidator,
} from '#util';

import {DefaultFieldValues, FieldValues} from './EditProfileForm.types';

export const getFormConfig = ({
  birthSex,
  birthday,
  firstName,
  height,
  heightDisplayUnit,
  lastName,
  pronouns,
  weight,
  weightDisplayUnit,
}: DefaultFieldValues) =>
  ({
    defaultValues: {
      birthSex: birthSex || BirthSex.Unknown,
      birthday: birthday || '',
      firstName: firstName || '',
      form: '',
      height: height || '',
      heightDisplayUnit: heightDisplayUnit || MeasurementUnit.Imperial,
      lastName: lastName || '',
      pronouns: pronouns || Pronoun.Unknown,
      weight: weight || '',
      weightDisplayUnit: weightDisplayUnit || MeasurementUnit.Imperial,
    } as FieldValues,
    mode: 'onBlur',
    resolver: yupResolver(
      object({
        birthday: dateValidator.required('Please enter your birthday'),
        firstName: stringValidator.required('Please enter your first name'),
        height: heightValidator(),
        heightDisplayUnit: measurementUnitRequiredValidator,
        lastName: stringValidator.required('Please enter your last name'),
        pronouns: pronounValidator,
        weightDisplayUnit: measurementUnitRequiredValidator,
        weight: numberValidator,
      }),
    ),
  } as const);
